import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface ExploreLink {
  to: string;
  label: string;
  hint: string;
}

const DEFAULT_LINKS: ExploreLink[] = [
  {
    to: "/tools",
    label: "Free investing calculators",
    hint: "Retirement, Coast FIRE, dividend income and rent vs buy — no signup.",
  },
  {
    to: "/halal-investing",
    label: "Halal investing guide",
    hint: "Screening, purification and building a Shariah-compliant portfolio.",
  },
  {
    to: "/blog",
    label: "PieFolio blog",
    hint: "Retirement numbers, dividend research and portfolio tracking guides.",
  },
];

interface ExploreMoreProps {
  title?: string;
  links?: ExploreLink[];
}

/**
 * Small, non-intrusive discovery block for otherwise dead-end pages
 * (legal pages, app-store landing pages) so visitors have a next step.
 */
const ExploreMore = ({ title = "Explore PieFolio AI", links = DEFAULT_LINKS }: ExploreMoreProps) => (
  <nav aria-label="Explore more of PieFolio AI" className="mt-12 pt-8 border-t border-border">
    <h2 className="text-lg font-bold mb-4">{title}</h2>
    <ul className="grid gap-3 sm:grid-cols-3">
      {links.map((link) => (
        <li key={link.to}>
          <Link
            to={link.to}
            className="group block h-full rounded-xl border border-border bg-card p-4 transition-colors hover:border-primary/50"
          >
            <span className="flex items-center gap-1.5 font-semibold text-foreground">
              {link.label}
              <ArrowRight className="w-4 h-4 text-primary transition-transform group-hover:translate-x-0.5" />
            </span>
            <span className="mt-1 block text-sm text-muted-foreground">{link.hint}</span>
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

export default ExploreMore;
